import React from 'react'

const Navbar = () => {
  return (
    <>
    <div class="w-22  h-full shadow-md bg-black rounded-r-3xl md:fixed relative ">
     
    
        <img src='./images\Untitled.png' alt='logo' className='w-22 rounded-r-3xl inline' />
        
    
        {/* <img src='./images\ahsan 1.png' alt='logo'  className=' inline object-right relative right-0 md:absolute md:bottom-0 md:left-0'/> */}
        
       
  
</div>

    </>
  )
}

export default Navbar;